import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import RetentionListPage, { LIST_COLORS as C } from './RetentionListPage';
import { TODAY_TASKS_HEAD } from './retentionTableHeads';
import { EmptyState, SectionCard, SoftChip } from '../components/ui';
import { getHomeTasks } from '../../../redux/features/retentionSlice';

const WARNINGS = [
  { key: 'overdue', label: 'Overdue with you', icon: 'solar:alarm-bold-duotone', color: C.red },
  { key: 'stuck', label: 'Stuck with you', icon: 'solar:hourglass-bold-duotone', color: C.amber },
  { key: 'flagged', label: 'Flagged for you', icon: 'solar:flag-bold-duotone', color: C.violet },
];

// /student-journey/tasks — every open stage across the CRO's students (§2.4).
export default function TodayTasks() {
  const { homeTasks } = useSelector((state) => state.retention);
  const warnings = homeTasks?.meta?.warnings || {};
  const navigate = useNavigate();

  return (
    <RetentionListPage
      title="Today's tasks"
      icon="solar:checklist-minimalistic-bold-duotone"
      headers={TODAY_TASKS_HEAD}
      fetchThunk={getHomeTasks}
      resource={homeTasks}
      endpoint="GET /retention/home-tasks"
      filterParam="view"
      filters={[
        { label: 'All', value: '' },
        { label: 'Overdue', value: 'overdue' },
        { label: 'Waiting on me', value: 'mine' },
        { label: 'Waiting on others', value: 'others' },
      ]}
      kpis={[
        { key: 'due_today', label: 'Due today', icon: 'solar:calendar-mark-bold-duotone', color: C.blue },
        { key: 'overdue', label: 'Overdue', icon: 'solar:alarm-bold-duotone', color: C.red },
        { key: 'waiting_on_others', label: 'Waiting on others', icon: 'solar:hourglass-bold-duotone', color: C.amber },
        { key: 'completed_today', label: 'Completed today', icon: 'solar:check-circle-bold-duotone', color: C.green },
      ]}
      side={WARNINGS.map((w) => {
        const items = Array.isArray(warnings[w.key]) ? warnings[w.key] : [];
        return (
          <SectionCard key={w.key} icon={w.icon} color={w.color} title={w.label} action={<SoftChip label={items.length} color={w.color} />}>
            {items.length === 0 ? (
              <EmptyState icon="solar:check-circle-linear" title="All clear" color={w.color} compact />
            ) : (
              <Stack gap={1}>
                {items.map((it, i) => (
                  <SoftChip
                    key={i}
                    label={`${it.student_name} · ${it.label}`}
                    color={w.color}
                    onClick={() => navigate(`/student-journey/${it.course_enrollment_id}`)}
                    sx={{ justifyContent: 'flex-start', cursor: 'pointer' }}
                  />
                ))}
              </Stack>
            )}
          </SectionCard>
        );
      })}
    />
  );
}
